// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2WNgT","content":"Consent_content__2y_Fe","footer":"Consent_footer__3rpAL"};